<template>
  <div>
    <section class="home-slider  inner-page owl-carousel">
      <div class="slider-item" style="background-image: url('/assets/img/slider-2.jpg');">
      </div>


    </section>
    <!-- END slider -->

    <section class="section">
      <div class="container">
        <div class="row mb-5 justify-content-end ">
          <div class="col-md-4">
            <img src="/assets/img/favicon.png" alt="Image placeholder" class="logo img-fluid">
          </div>
          <div class="col-md-8 text-right">
            <h2 class="text-uppercase heading mb-4">تاريخ الشركه</h2>
            <p class="mb-4">تأسست عام 1995 م علي يد المهندس محمد الديب حاصل علي بكالريوس في الهندسه المدنيه وماجستير في
              اداره المشروعات</p>
            <p>
              شركة الديب للتشييد والبناء من الشركات الرائدة في مجالات الهندسة والمقاولات العامة والديكور والتنمية
              العقارية لما تحتويه الشركة من فريق عمل كامل من افضل المهندسين الانشائين والمعمارين ومهندسين الديكور
              ومجموعة من الفنيين والعمالة المهنية في جميع المجالات
            </p>
          </div>

        </div>
        <div class="row justify-content-end mb-5">
          <div dir="rtl" class="col-12 text-right">
            <h2 class="text-uppercase heading mb-4">انشطه الشركة</h2>

            <p class="mb-4">
              تعمل الشركة فى مجال المقاولات فى كل من  :
            </p>

            <ul class="list-unstyled check" dir="rtl">
              <li>أعمال المبانى</li>
              <li>تشطيبات للمبانى</li>
              <li>مدارس</li>
              <li>فيلات</li>
              <li>فنادق</li>
            </ul>
          </div>

        </div>

        <div class="row justify-content-end mb-5">
          <div dir="rtl" class="col-12 text-right">
            <h2 class="text-uppercase heading mb-4">اهداف الشركة</h2>

            <p class="mb-4"> يعمـــل مجلـــس ادارة الشـــركة منـــذ اعادة تشكيله وفقا لقــرار السيد المهندس رئيس مجلس
              الاداره بنظام واليه عمل محدد وموزع به الاختصاصات لتحقيق الاداء والاهداف الاتية:-
            </p>

            <ul class="list-unstyled check" dir="rtl">
              <li> مسايرة التطور العالمي في صناعة التشييد والبناء
              </li>
              <li> الإرتفاع والرقي بمستوى أداء الشركـــة ليرقى دائما للمستوى العالمي</li>
              <li>تحقيق وتطوير حجم العمل بالشركة سواء محليا أو خارجيا</li>
              <li> تخفيض المصروفات والتكاليـــــــف</li>
              <li>تحقيق ارباح نشاط ، وفائض محقــق سنويا ، مع الحفاظ على الجودة المتميزة</li>
              <li> تطوير كامل لنظم المعلومات بالشركة وميكنة هذه النظم مع استخدام الحاسبات فى كل اعمال الشركة
              </li>
              <li>العمل المستمر على الحفاظ ورفع سمعه الشركة وادائها لدى العملاء وهذا ناتج عن هدف اول للمجلس هو العلاقة
                الجيدة بين الادارة والعاملين والانضباط الداخلى بالشركة الذى يؤدى بالتزام الشركة بمواعيدها امام العملاء
              </li>
            </ul>
          </div>

        </div>

        <div class="row justify-content-end mb-5">
          <div dir="rtl" class="col-12 text-right">
            <h2 class="text-uppercase heading mb-4">رؤية الشركة</h2>

            <p class="mb-4">تتلخص رؤية الشركة بأن تكون أحد اهم الشركات الرائده و الموثوقة في مجال الخدمات الهندسية سواء
              في التصميم أو الاشراف علي تنفيذ المشاريع وفق رؤية شامله واضحه من خلال السواعد التي تتمتع بها الشركة
              للانطلاقه نحو العالمية.</p>

            <ul class="list-unstyled check" dir="rtl">
              <li>أن نقدم حلولا هندسيه مبتكره لتحسين اسلوب حياه عملائنا في كل مكان.</li>
              <li> مهمتنا أن نكون أكثر الشركات الهندسية نجاحا من خلال خدمات متميزه ووسائل تقنيه حديثه و موظفين أكفاء و
                مشاريع مطابقه لاعلي المواصفات الهندسيه .
              </li>
              <li>قيمنا مساعده عملاءنا في تحقيق أهدافهم و نلتزم بتلبيه كافه احتياجات عملائنا بل تقديم خدمات تفوق
                توقعاتهم.
              </li>
            </ul>
          </div>

        </div>
      </div>
    </section>

    <section class="section border-t">
      <div class="container">
        <div class="row justify-content-center mb-5">
          <div class="col-md-8 text-center mb-5">
            <h2 class="text-uppercase heading border-bottom mb-4">فريق العمل</h2>
            <p class="mb-0 lead">يتكون فريقنا من عدد من المهندسين و المصممين الخبراء ذوى المواهب و الافكار الجديدة
              لتقديم افضل الحلول للتصميم يضع عملائه على ادراك بكل شىء فى المشروع.
            </p>
          </div>
        </div>

        <div class="row justify-content-center">

          <div class="col-md-4">
            <div class="media d-block media-testimonial text-center">
              <img src="/assets/img/employees/1.jpeg" alt="Image placeholder" class="employee img-fluid mb-3">
              <h5>محمد ابراهيم الديب</h5>
              <p>رئيس مجلس الاداره</p>
            </div>
          </div>
        </div>

        <div class="row justify-content-center">
          <div class="col-md-4">
            <div class="media d-block media-testimonial text-center">
              <img src="/assets/img/employees/2.jpeg" alt="Image placeholder" class="employee img-fluid mb-3">
              <h5>احمد عبدالغفار</h5>
              <p>مدير مشروعات</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="media d-block media-testimonial text-center">
              <img src="/assets/img/employees/3.jpeg" alt="Image placeholder" class="employee img-fluid mb-3">
              <h5>محمد حامد</h5>
              <p>مهندس كهربا</p>
            </div>
          </div>
        </div>

        <div class="row justify-content-center">
          <div class="col-md-4">
            <div class="media d-block media-testimonial text-center">
              <img src="/assets/img/employees/6.jpeg" alt="Image placeholder" class="employee img-fluid mb-3">
              <h5>محمد سعد</h5>
              <p>مدير IT</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="media d-block media-testimonial text-center">
              <img src="/assets/img/employees/4.jpeg" alt="Image placeholder" class="employee img-fluid mb-3">
              <h5>ايهاب منصور</h5>
              <p>مدير مالي</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="media d-block media-testimonial text-center">
              <img src="/assets/img/employees/5.jpeg" alt="Image placeholder" class="employee img-fluid mb-3">
              <h5>محروس مغاوري</h5>
              <p>مدير اداري</p>
            </div>
          </div>

        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "About",
  mounted() {
    // home slider
    $('.home-slider').owlCarousel({
      loop: true,
      autoplay: true,
      margin: 10,
      animateOut: 'fadeOut',
      animateIn: 'fadeIn',
      nav: true,
      autoplayHoverPause: true,
      items: 1,
      navText: ["<span class='ion-chevron-left'></span>", "<span class='ion-chevron-right'></span>"],
      responsive: {
        0: {
          items: 1,
          nav: false
        },
        600: {
          items: 1,
          nav: false
        },
        1000: {
          items: 1,
          nav: true
        }
      }
    });
  }
}
</script>

<style scoped>
.logo {
  width: 70%;
  object-fit: cover;
}

.employee {
  object-fit: cover;
  width: 100px;
  height: 100px;
}

.list-unstyled li {
  margin-bottom: 20px;
}
</style>